<script>
import ContentBox from '@/components/ui/ContentBox';

export default {
  name: 'Error',
  components: {
    ContentBox
  },
  props: {
    statusCode: {
      type: Number,
      default: 500
    }
  },
  computed: {
    content() {
      switch (this.statusCode) {
        case 404: // not found
          return {
            image: require('@/assets/surveillance-camera.svg'),
            title: this.$t('Not Found'),
            message: this.$t('The page you requested could not be found.')
          };

        case 410: // gone
          return {
            image: require('@/assets/toolbox.svg'),
            title: this.$t('Out of Service'),
            message: this.$t('This domain is no longer active.')
          };

        default:
          // server error
          return {
            image: require('@/assets/crane.svg'),
            title: this.$t('Server Error'),
            message: this.$t('An error occurred. Please try your request again later.')
          };
      }
    }
  }
};
</script>

<template>
  <div class="container">
    <content-box class="content">
      <span class="image">
        <img :src="content.image" :alt="content.title">
      </span>
      <h1>{{ content.title }}</h1>
      <p>
        {{ content.message }}
      </p>
      <el-button type="primary" size="large" block @click="$router.push('/')">
        {{ $t('Homepage') }}
      </el-button>
    </content-box>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

@keyframes swing {
  0% {
    transform: rotate(2deg);
  }
  50% {
    transform: rotate(-2deg);
  }
  100% {
    transform: rotate(2deg);
  }
}

.container {
  background-color: $--color-gray-10;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.content {
  text-align: center;
  animation: 10s ease 0s normal none infinite swing;
  transform-origin: center top;

  .image {
    img {
      display: block;
      max-width: 16rem;
      max-height: 16rem;
      margin: 0 auto;
    }
  }

  h1 {
    font-size: 3rem;
    margin: 1rem 0;
  }

  p {
    margin-bottom: 2rem;
  }
}
</style>
